import { connect } from 'react-redux';
import Loader from './Loader';

const mapStateToProps = state => {
  const { showLoader } = state;

  return {
    disable: !showLoader
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
